import { render, staticRenderFns } from "./SettlementHeader.vue?vue&type=template&id=85440904"
import script from "./SettlementHeader.vue?vue&type=script&lang=js"
export * from "./SettlementHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports